export const saveContainerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0px 0px 0px 0px'
};

export const saveButtonStyle = {
    minWidth: 110,
    maxWidth: 'max-content',
    padding: '0 15px',
    height: 40,
    fontSize: 15,
    fontWeight: 'bold',
    borderRadius: 5
};

export const cancelCampaignButtonStyle = {
    width: 148,
    height: 40,
    fontSize: 15,
    fontWeight: 'bold',
    borderRadius: 5
};

export const discardAmendmentCampaignButtonStyle = {
    width: 182,
    height: 40,
    fontSize: 15,
    fontWeight: 'bold',
    borderRadius: 5,
    marginRight: 115,
    marginLeft: -196
};

export const stickySaveContainerStyle = {
    ...saveContainerStyle,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, .2)',
    position: 'sticky',
    bottom: 0,
    height: 50,
    zIndex: 1000
};

export const stickySaveButtonStyle = {
    ...saveButtonStyle,
    marginRight: 0
};
